// Google Ads conversion tracking (tag AW-18438836013 is loaded once in public/index.html).
// CONFIGURATION: paste the conversion-action labels from Google Ads below. An empty label means the event is skipped —
// nothing is sent to Google until the real label is present. Never put placeholder/fake labels here.
export const ADS_ID = "AW-18438836013";
export const CONVERSION_LABELS = {
  signup: "t-7mCPTsyvocEK2eqdhE", // Google Ads → Conversions → "Fire Prep Sign-up" (code event; counting = One)
  premium_purchase: "",       // "Premium purchase completed" (set counting to "One" in Google Ads)
  mock_interview_started: "", // "Mock interview started"
  resume_builder_started: "", // "Resume Builder started"
};

export function trackConversion(name, params = {}) {
  const label = CONVERSION_LABELS[name];
  if (!label || typeof window === "undefined" || typeof window.gtag !== "function") return false;
  window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, ...params }); // no PII is ever passed here
  return true;
}

// Purchase: fire once per Stripe Checkout session (transaction_id dedupes in Google Ads; localStorage guards refreshes).
export function trackPurchaseOnce(sessionId, valueUsd, currency = "USD") {
  if (!sessionId) return false;
  const key = `fp_conv_purchase:${sessionId}`;
  try { if (localStorage.getItem(key)) return false; } catch { /* storage unavailable → still send once */ }
  const params = { transaction_id: sessionId, currency };
  if (typeof valueUsd === "number" && valueUsd > 0) params.value = valueUsd;
  const sent = trackConversion("premium_purchase", params);
  try { localStorage.setItem(key, "1"); } catch { /* ignore */ }
  return sent;
}
